export const healthTips = [
  {
    title: "Stay Hydrated",
    body: "Drink at least 8-10 glasses of water daily to maintain optimal body functions, improve digestion, and keep your skin healthy."
  },
  {
    title: "Regular Exercise",
    body: "Aim for at least 30 minutes of moderate physical activity daily. Walking, cycling, or swimming can boost your energy and strengthen your immune system."
  },
  {
    title: "Balanced Diet",
    body: "Include fruits, vegetables, whole grains, lean proteins, and healthy fats in your meals. Avoid processed foods and limit sugar intake."
  },
  {
    title: "Adequate Sleep",
    body: "Get 7-9 hours of quality sleep each night to help your body repair, improve memory, and regulate hormones."
  },
  {
    title: "Wash Hands Regularly",
    body: "Wash your hands with soap and water for at least 20 seconds, especially before eating and after using the restroom, to prevent infections."
  },
  {
    title: "Take Prescribed Medications Correctly",
    body: "Always follow your doctor's instructions and complete the full course of prescribed medications, even if you start feeling better."
  },
  {
    title: "Manage Stress",
    body: "Practice relaxation techniques like deep breathing, meditation, or yoga. Taking breaks and spending time with loved ones can also reduce stress."
  },
  {
    title: "Regular Health Check-ups",
    body: "Schedule annual physical exams and screenings. Early detection of health issues leads to better treatment outcomes."
  },
  {
    title: "Protect Yourself from Sun",
    body: "Use sunscreen with SPF 30 or higher, wear protective clothing, and avoid prolonged sun exposure between 10 AM and 4 PM."
  },
  {
    title: "Limit Alcohol Consumption",
    body: "If you drink alcohol, do so in moderation. Excessive drinking can lead to liver damage, heart problems, and other health issues."
  },
  {
    title: "Quit Smoking",
    body: "Smoking increases the risk of heart disease, stroke, lung cancer, and respiratory problems. Seek support to quit smoking for better health."
  },
  {
    title: "Maintain Good Posture",
    body: "Sit and stand straight to prevent back pain and muscle strain. Use ergonomic furniture and take breaks from sitting."
  },
  {
    title: "Practice Good Oral Hygiene",
    body: "Brush your teeth twice daily, floss regularly, and visit your dentist every six months to prevent dental problems."
  },
  {
    title: "Stay Socially Connected",
    body: "Maintain relationships with family and friends. Social connections improve mental health and can help you live longer."
  },
  {
    title: "Limit Screen Time",
    body: "Take regular breaks from screens every 20-30 minutes to prevent eye strain, headaches, and maintain good posture."
  },
  {
    title: "Eat Breakfast",
    body: "Start your day with a nutritious breakfast to boost metabolism, improve concentration, and provide energy for the day."
  },
  {
    title: "Practice Portion Control",
    body: "Be mindful of portion sizes to maintain a healthy weight. Use smaller plates and chew your food slowly to aid digestion."
  },
  {
    title: "Include Fruits and Vegetables",
    body: "Aim for at least 5 servings of fruits and vegetables daily. They're rich in vitamins, minerals, and fiber essential for good health."
  },
  {
    title: "Stay Active Throughout the Day",
    body: "Take the stairs instead of the elevator, walk during breaks, and find opportunities to move throughout your day."
  },
  {
    title: "Prioritize Mental Health",
    body: "Don't hesitate to seek professional help if you're struggling with mental health issues. Taking care of your mind is as important as physical health."
  },
  {
    title: "Read Medication Labels",
    body: "Always read medication labels carefully. Check dosage instructions, expiry dates, and potential side effects before taking any medication."
  },
  {
    title: "Store Medications Properly",
    body: "Keep medications in a cool, dry place away from direct sunlight and out of reach of children. Some medications require refrigeration."
  },
  {
    title: "Never Share Prescriptions",
    body: "Only use medications prescribed to you. Sharing medications with others can be dangerous and lead to serious health complications."
  },
  {
    title: "Maintain a Health Journal",
    body: "Keep track of your symptoms, medications, and health concerns to help your doctor make better-informed decisions about your care."
  }
];

export default healthTips;
